export default {
  // Tiêu đề trang
  title: "Thống kê đẩy",
  
  // Biểu mẫu tìm kiếm
  searchForm: {
    pushTime: "Thời gian đẩy",
    pushTimePlaceholder: "Vui lòng chọn khoảng thời gian",
    memberAccount: "Thành viên đẩy",
    memberAccountPlaceholder: "Vui lòng nhập",
    pushType: "Loại đẩy",
    pushTypePlaceholder: "Vui lòng chọn",
    search: "Truy vấn",
    reset: "Đặt lại"
  },
  
  // Tiêu đề cột bảng
  table: {
    memberAccount: "Thành viên đẩy",
    pushType: "Loại đẩy",
    subPushType: "Loại phụ",
    pushTitle: "Tiêu đề đẩy",
    pushContent: "Nội dung đẩy",
    pushTime: "Thời gian đẩy",
    status: "Trạng thái",
    createTime: "Thời gian tạo"
  },
  
  // Trường
  pushName: "Tên tin nhắn",
  pushType: "Loại đẩy",
  subPushType: "Loại phụ",
  pushTime: "Thời gian gửi",
  createTime: "Thời gian thao tác",
  createUserName: "Người thao tác",
  sendUserCount: "Số lượng người dùng gửi",
  pushSuccessToFailed: "Tổng đẩy/Đến",
  pushOpenCount: "Số lượng mở đẩy",
  pushOpenRate: "Tỷ lệ mở đẩy",
  pleaseEnter: "Vui lòng nhập"
};
